// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"ChangePassword_mainDiv__iMHS9","statement":"ChangePassword_statement__1pf5r","statementMazda":"ChangePassword_statementMazda__3iMYD"};